import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { GradientIcon } from 'src/components/gradients/GradientIcon';
import type { AuthenticationFlowPageProps } from '../AuthenticationFlow';
import type { LoginMethodType } from '../login-stack/LoginMethods';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import theme from 'src/styles/theme';
import { useSelector } from 'react-redux';
import type { RootState } from '../store';
import { AuthenticationCloseButton } from '../AuthenticationCloseButton';

type AuthenticationFlowCompletePageProps = AuthenticationFlowPageProps & {
  closeModal: () => void;
};

export function AuthenticationFlowCompletePage({
  pageId: pageID,
  onPageComplete,
  closeModal,
}: AuthenticationFlowCompletePageProps) {
  const registrationMethod = useSelector(
    (state: RootState) => state.loginMethod,
  );

  const accountStatus = useSelector((state: RootState) => state.accountStatus);

  if (!pageID || !onPageComplete) return null;

  const registrationTitleMap: { [K in LoginMethodType | 'none']: string } = {
    discord: 'Discord Account Confirmed',
    twitter: 'Twitter Account Confirmed',
    google: 'Google Account Confirmed',
    phone: 'Phone Number Confirmed',
    email:
      accountStatus === 'existing'
        ? 'Credentials Confirmed'
        : 'Registration Complete',
    wallet: 'Wallet Confirmed',
    none: 'Account Confirmed',
  };

  return (
    <Box>
      <Box position="absolute" top="16px" right="16px">
        <AuthenticationCloseButton closeModal={closeModal} />
      </Box>
      <Stack spacing={'64px'} my={'22px'} mx={'96px'}>
        <Stack spacing={'8px'}>
          <Typography
            variant="h4"
            fontWeight="500"
            textTransform={'capitalize'}
            textAlign={'center'}
          >
            {registrationTitleMap[`${registrationMethod}`]}
          </Typography>
          <Typography variant="body1" textAlign={'center'}>
            Welcome to BluMint!
          </Typography>
        </Stack>
        <Box textAlign={'center'}>
          <GradientIcon
            IconComponent={CheckCircleIcon}
            gradientColor="secondary.horizontal"
            sx={{ fontSize: '146px' }}
          />
        </Box>
        <Stack spacing={'8px'} alignItems={'stretch'}>
          {['Edit Profile Page', 'Connect Wallet'].map(
            (buttonMessage, index) => {
              return (
                <Button
                  variant="outlined"
                  size="large"
                  color="primary"
                  key={`${buttonMessage} ${index}`}
                >
                  <Typography
                    textTransform={'uppercase'}
                    sx={{ margin: '8px 0' }}
                    color="white"
                  >
                    {buttonMessage}
                  </Typography>
                </Button>
              );
            },
          )}
          <Button
            variant="contained"
            size="large"
            onClick={() => onPageComplete(pageID)}
            sx={{ background: theme.palette.secondary.vertical }}
          >
            <Typography textTransform={'uppercase'} color="white">
              Continue Browsing
            </Typography>
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}
